import React from "react";
import Footer from "../../Components/Footer/footer";
import { FcComboChart } from "react-icons/fc";
import { useSelector } from "react-redux";
import { useState } from "react";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import OrdersRevenueTable from "./Orders Revenue/revenue_table";
import RevenueChart from "./Orders Revenue/revenue_charts";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";

const OrdersRevenue = () => {
  const store = useSelector((store) => store.login.user);
  const [ordersFrom, setOrdersFrom] = useState(30);
  const [ordersOf, setOrdersOf] = useState(
    store.Role === process.env.REACT_APP_ROLE_ADMIN ||
      store.Role === process.env.REACT_APP_ROLE_ADMIN_S
      ? "All"
      : "Farmers"
  );
  const [selectFP, setSelectFP] = useState("All");
  const [selectFPId, setSelectFPID] = useState("");

  const [selectFPForRVN, setSelectFPForRVN] = useState("All");
  const [selectFPForRVNId, setSelectFPForRVNID] = useState("");
  const [ordersData, setOrdersData] = useState();
  const [farmerPartner, setFarmerPartner] = useState();
  const [ordersTallyOf, setOrdersTallyOf] = useState(
    store.Role === process.env.REACT_APP_ROLE_ADMIN ||
      store.Role === process.env.REACT_APP_ROLE_ADMIN_S
      ? "Kryzen"
      : "Farmers"
  );
  const [ordersTallyData, setOrdersTallyData] = useState();
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    performRequest("POST", `/pmg/cf-orders/all-orders-revenue-graph/`, {
      ordersOf,
      fpId: ordersOf === "Farmers" ? selectFPId : "",
    })
      .then((res) => {
        if (res.status === 200) {
          setOrdersData(res?.data?.OrdersData);
        } else {
          Toast("error", "Error while getting Orders data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [ordersOf, selectFPId]);
  useEffect(() => {
    performRequest(
      "POST",
      getFilteredURL("/pmg/cf-orders/all-orders-revenue/", page),
      {
        ordersOf: ordersTallyOf,
        fpId: ordersTallyOf === "Farmers" ? selectFPForRVNId : "",
      }
    )
      .then((res) => {
        if (res.status === 200) {
          setOrdersTallyData(res?.data?.OrdersData);
          setTotalPages(Math.ceil(res.data?.OrdersCount / 20));
        } else {
          Toast("error", "Error while getting Orders data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [page, ordersTallyOf, selectFPForRVNId]);
  useEffect(() => {
    performRequest("GET", "/pmg/cf-orders/all-fp-su")
      .then((res) => {
        if (res.status === 200) {
          setFarmerPartner(res?.data?.farmers);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcComboChart
                    className="fs-2  me-1"
                    style={{ color: "yellow" }}
                  />
                  Orders Revenue
                </h2>
                <h4 className="text-muted m-0 p-0">Track orders revenue.</h4>
              </div>
            </div>
          </div>
          <div className="row row-deck row-cards">
            <div className="col-md-3 d-none d-lg-block d-md-block mt-2">
              <CustomViedoCard
                viedoLink={"https://www.youtube.com/embed/OByxvBLEWsE"}
                id={"model-viedo"}
                name={"orders revenue"}
              ></CustomViedoCard>
            </div>
            <div className="col-md-9">
              <div className="card text-center">
                <div className="card-header">
                  <h3 className="card-title">Daily Revenue Chart</h3>
                  <div className="ms-auto">
                    <div className="d-flex">
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN) &&
                        ordersOf === "Farmers" && (
                          <div className="me-2">
                            <div className="dropdown">
                              <a
                                className="dropdown-toggle text-muted"
                                href="/"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {selectFP}
                              </a>
                              <div className="dropdown-menu dropdown-menu-end">
                                <span
                                  onClick={() => {
                                    setSelectFP("All");
                                    setSelectFPID("");
                                  }}
                                  className="dropdown-item"
                                >
                                  All
                                </span>
                                {farmerPartner?.map((el) => {
                                  return (
                                    <span
                                      key={el.id}
                                      onClick={() => {
                                        setSelectFP(el.userName);
                                        setSelectFPID(el.id);
                                      }}
                                      className="dropdown-item"
                                    >
                                      {el.userName}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                        <div className="mx-2">
                          <div className="dropdown">
                            <a
                              className="dropdown-toggle text-muted"
                              href="/"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {ordersOf}
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                              <span
                                onClick={() => setOrdersOf("All")}
                                className="dropdown-item"
                              >
                                All
                              </span>

                              <span
                                onClick={() => setOrdersOf("Kryzen")}
                                className="dropdown-item"
                              >
                                Kryzen
                              </span>
                              <span
                                onClick={() => setOrdersOf("Kryzen-CNF")}
                                className="dropdown-item"
                              >
                                Kryzen-CNF
                              </span>
                              <span
                                Revenue
                                onClick={() => setOrdersOf("Farmers")}
                                className="dropdown-item"
                              >
                                Farmers
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="ms-2 dropdown">
                        <a
                          className="dropdown-toggle text-muted"
                          href="/"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Last {ordersFrom || 30} days
                        </a>
                        <div className="dropdown-menu dropdown-menu-end">
                          <span
                            onClick={() => setOrdersFrom(7)}
                            className="dropdown-item"
                          >
                            Last 7 days
                          </span>
                          <span
                            onClick={() => setOrdersFrom(30)}
                            className="dropdown-item"
                          >
                            Last 30 days
                          </span>
                          <span
                            onClick={() => setOrdersFrom(45)}
                            className="dropdown-item"
                          >
                            Last 45 days
                          </span>
                          <span
                            onClick={() => setOrdersFrom(60)}
                            className="dropdown-item"
                          >
                            Last 2 months
                          </span>
                          <span
                            onClick={() => setOrdersFrom(90)}
                            className="dropdown-item"
                          >
                            Last 3 months
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="text-center d-flex justify-content-center align-items-center"
                  style={{ maxHeight: "470px" }}
                >
                  {ordersData && ordersData.length > 0 && (
                    <RevenueChart
                      ordersData={ordersData}
                      ordersFrom={ordersFrom}
                      ordersOf={ordersOf}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3"></div>
            <div className="col-md-9">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Revenue Trasactions:</h3>
                  <div className="ms-auto">
                    <div className="d-flex">
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN) &&
                        ordersTallyOf === "Farmers" && (
                          <div className="me-2">
                            <div className="dropdown">
                              <a
                                className="dropdown-toggle text-muted"
                                href="/"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {selectFPForRVN}
                              </a>
                              <div className="dropdown-menu dropdown-menu-end">
                                <span
                                  onClick={() => {
                                    setSelectFPForRVN("All");
                                    setSelectFPForRVNID("");
                                  }}
                                  className="dropdown-item"
                                >
                                  All
                                </span>
                                {farmerPartner?.map((el) => {
                                  return (
                                    <span
                                      key={el.id}
                                      onClick={() => {
                                        setSelectFPForRVN(el.userName);
                                        setSelectFPForRVNID(el.id);
                                      }}
                                      className="dropdown-item"
                                    >
                                      {el.userName}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                        store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                        <div className="me-2">
                          <div className="dropdown">
                            <a
                              className="dropdown-toggle text-muted"
                              href="/"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {ordersTallyOf}
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                              <span
                                onClick={() => {
                                  setOrdersTallyOf("Kryzen");
                                  setPage(1);
                                }}
                                className="dropdown-item"
                              >
                                Kryzen
                              </span>
                              <span
                                onClick={() => {
                                  setOrdersTallyOf("Kryzen-CNF");
                                  setPage(1);
                                }}
                                className="dropdown-item"
                              >
                                Kryzen-CNF
                              </span>
                              <span
                                onClick={() => {
                                  setOrdersTallyOf("Farmers");
                                  setPage(1);
                                }}
                                className="dropdown-item"
                              >
                                Farmers
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card">
                    <OrdersRevenueTable
                      ordersTallyOf={ordersTallyOf}
                      ordersTally={ordersTallyData}
                      currentPage={page}
                      itemsPerPage={20}
                    />

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={ordersTallyData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-lg-none">
            <CustomViedoCard
              viedoLink={"https://www.youtube.com/embed/OByxvBLEWsE"}
              id={"model-viedo2"}
              name={"orders revenue"}
            ></CustomViedoCard>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default OrdersRevenue;
